module.exports = __webpack_public_path__ + "fonts/NunitoSans-Regular.c8c88f3.woff2";